module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_TUBE SKID_LHD.25d4cf38.jpg";